'use strict'

import * as Filepond from 'filepond';

class FileUpload {
    constructor() {
        this.init();
    }

    /**
     * Initialize the file upload.
     */
    init() {
        $('[data-mediaupload]').each((_index, htmlElement) => {
            Filepond.create(htmlElement, {
                storeAsFile: true,
                labelIdle: '<span class="filepond--label-text">Logo-Datei hier ablegen oder <span class="filepond--label-action">Datei suchen</span></span>',
            });
        })
    }
}

export default new FileUpload();
